import { PdfHeader } from '../pdfHeader';
import { PdfFooter } from '../pdfFooter';
import { PdfTable } from '../infoPage/table';
import { InfoTitle } from '../infoPage/title';
import { Page, Text, View } from '@react-pdf/renderer';
import { PortCoPageProps } from 'interfaces/components/dashboardPdf';

export const SecondPage = ({
  data,
  columns,
  pagesCount,
  companyName,
  companyInfo
}: PortCoPageProps) => {
  return (
    <Page
      size='A4'
      orientation='landscape'
      style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}
    >
      <PdfHeader />

      <View
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '4px',
          marginTop: '8px',
          paddingHorizontal: '20px'
        }}
      >
        <InfoTitle
          name={companyName}
          status={companyInfo.requiredInfo.status || ''}
          website={companyInfo.companyDetails.companyWebsite}
        />

        <Text
          style={{ fontSize: '10px', fontWeight: 'light', color: '#5C5C5C' }}
        >
          Below, you'll find the user parameters you provided, along with
          corresponding graphs that visualize these comparisons.
        </Text>
      </View>

      <PdfTable
        columns={columns}
        data={data.slice(12, 25)}
        title='KEY FINANCIALS SECTION'
      />

      <PdfTable
        columns={columns}
        data={data.slice(25, 32)}
        title='GROWTH AND RETENTION'
      />

      <PdfFooter pageNumber={2} pagesCount={pagesCount} />
    </Page>
  );
};
